module.exports = __webpack_public_path__ + "img/8.5f5bd640.png";